var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormFieldSpinnerDown = function SvgFormFieldSpinnerDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 9,
    height: 9,
    viewBox: "0 0 8 5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.2.7 0 0 .8l4 4 4-4-.8-.8z"
  })));
};
export default SvgFormFieldSpinnerDown;